import { useContext } from 'react';
import { AuthContext } from '../context/jwt';

const useAuth = () => useContext(AuthContext);

export default useAuth;